import { render, staticRenderFns } from "./createCategoria.vue?vue&type=template&id=691704be&scoped=true&"
import script from "./createCategoria.vue?vue&type=script&lang=js&"
export * from "./createCategoria.vue?vue&type=script&lang=js&"
import style0 from "./createCategoria.vue?vue&type=style&index=0&id=691704be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691704be",
  null
  
)

export default component.exports